<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 2000 - 2020</span>
        <h2>保障人權</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/judge/judge-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/judge/judge.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/楊竣傑</small></p>
      <p>1935年7月1日，《刑法》第 239 條「有配偶而與人通姦者，處一年以下有期徒刑。其相姦者亦同。」正式施行。</p>
      <figure class="article-img">
        <img src="../../assets/images/judge/pic-01.png" alt="">
        <figcaption>葉啟洲任職高雄地方法官時，聲請通姦罪釋憲。</figcaption>
      </figure>
      <p>二十年前仍是高雄地方法院候補法官、現為政治大學法學院教授葉啟洲回憶，當時讓他起心動念提起釋憲的案子，其中一原告楊姓男子，2000年與林姓妻子離婚，事後發現林女離婚前卻外遇生子憤而提告，和妻子分居後也離婚的楊男說：「她和別人同居時，我們仍是夫妻，就不能發生關係，法律得還我公道。」</p>
      <p>當時通姦罪成為民眾以訴訟報復另一半，或期待提告後，仍可維繫岌岌可危婚姻虛幻想像的工具。葉啟洲認為，「婚姻應是合夥關係，沒有互信就拆夥，沒有外力能讓每個人的婚姻過得更好。」更何況楊男與前妻已逾五年無共同生活，婚姻早已名存實亡。</p>
      <p>法律合理性的思辨，讓葉啟洲任職地院未滿八個月，就大膽挑戰遊戲規則。當年11月，他提出通姦罪釋憲聲請書，但2002年12月，時任大法官做出釋字第五五四號解釋，宣告通姦罪「合憲」。</p>
      <p>挑戰雖未成功，葉啟洲固然失望，但他清楚此論點在當時是非主流想法，「至少可埋下一顆種子，讓社會知道，有人勇於提出質疑。」</p>
      <figure class="article-img">
        <img src="../../assets/images/judge/pic-02.png" alt="">
        <figcaption>陳文貴任職於苗栗地方法院時，申請通姦罪釋憲。</figcaption>
      </figure>
      <p>台灣高等法院法官陳文貴，2015年任職於苗栗地方法院時，處理一件通姦案，李姓陸籍配偶與湯姓丈夫分居多年，毫無夫妻之實，兩人各自有新感情及生子，李女2015年得知丈夫外遇，便控告湯男與外遇對象阮女通姦。</p>
      <p>「兩人都通姦，但大陸因無通姦罪，丈夫告不成，反因台灣的通姦罪而挨告、被起訴，根本就有問題。」他訴說當時接到此案的反應，直呼荒謬。</p>
      <p>「社會、人情與世界都在變化，連韓國通姦罪都除罪化，難道我們連韓國都不如？」陳文貴指出，即使法務部不斷強調七、八成民眾反對廢除通姦罪，「法律得符合比例原則，情感層面是鄉民在講的，否則判決不必靠法官，靠i-Voting就好。」陳文貴語畢笑說，「總要有人革命，衝到前面，才有人跟上啊。」</p>
      <p>這股想改變的熱情，促使陳文貴於2015年、葉啟洲聲請釋憲的十五年後，終於再點燃通姦罪違憲的火把。其後五年，總計十九名法官提出釋憲聲請，這股集結的力量，一起遙指共同的終點：「憲法法庭」。</p>
      <figure class="article-img">
        <img src="../../assets/images/judge/pic-03.png" alt="">
        <figcaption>2019年5月，同婚合法施行。</figcaption>
      </figure>
      <p>2017年大法官宣告《民法》未保障同性婚姻違憲，婚姻中的人格自主權更被尊重。2019年5月24日《司法院釋字第七四八號解釋施行法》（同婚法）施行，成為亞洲第一個同婚合法國家。</p>
      <p>2020年5月29日下午4點，憲法法庭審判長、大法官許宗力，緩緩朗讀釋字第七九一號「通姦罪及撤回告訴之效力案」解釋文。</p>
      <p>雖只用95秒宣讀解釋文，但這艘名為「通姦除罪化」的大船，卻是跨世代司法官，一棒接一棒奮力划了二十年，才艱辛促使大法官兩度釋憲，終於靠岸的成果，讓八十五年來國家刑罰權介入私人關係的通姦罪正式走進歷史。</p>
      <p>「同樣是參與婚外性行為，女性通姦者遭到社會斥為淫娃蕩婦，而男性通姦者都只是犯了『天下男人都會犯的錯』。社會顯然還有很長一段需要共同學習成長的路要走。」許宗力這段鏗鏘有力的見解，如同掀開台灣長久在通姦罪下，不願面對法律不合時宜的真相，也讓社會重新省思對於家庭與婚姻的真諦。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
